var map = {
	"./ajax.png": 9481,
	"./apache.png": 1505,
	"./boostrap.png": 2657,
	"./css.png": 1642,
	"./express.png": 259,
	"./git.png": 9599,
	"./html.png": 2288,
	"./js.png": 7594,
	"./mongo.png": 8959,
	"./node.png": 267,
	"./p5.png": 5842,
	"./php.png": 5095,
	"./py.png": 2942,
	"./react.png": 8242,
	"./remix.png": 5776,
	"./vs.png": 7286,
	"./wp.png": 9730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7388;